import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Typography } from '../typography';

const SIDE_PADDING = 8;
const TIME_SIZE = 40;
const HOUR_WIDTH = 40;
const MINUTES_WIDTH = 4 * TIME_SIZE;
const WIDTH = HOUR_WIDTH + MINUTES_WIDTH + SIDE_PADDING * 2;
const HEIGHT = 320;

export const TimePickerContainerElement = styled.div`
    position: relative;
    flex-grow: 1;
`;

export const TimePickerDialogWrapperElement = styled.div`
    justify-content: center;
    display: flex;
`;

export const TimePickerElement = styled.div`
    width: ${WIDTH}px;
    height: ${HEIGHT}px;
    overflow: hidden;
`;

export const ScrollContainerElement = styled.div`
    width: ${WIDTH + 20}px;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: ${getToken('backgroundStaticFloating')};
`;

export const HourElement = styled.div`
    box-sizing: border-box;
    width: ${WIDTH}px;
    padding: ${getSpacingToken('50')}px ${SIDE_PADDING}px;
    display: flex;
    justify-content: space-around;
    border-bottom: ${getToken('borderWidth100')}px solid ${getToken('borderInteractiveSecondaryDefault')};
`;

export const HourLabelElement = styled(Typography)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${HOUR_WIDTH}px;
    height: ${TIME_SIZE}px;
`;

export const MinutesContainerElement = styled.div`
    width: ${MINUTES_WIDTH}px;
`;

interface TimeElementProps {
    selected?: boolean;
    time?: string;
}

export const TimeElement = styled(Typography)<TimeElementProps>`
    width: ${TIME_SIZE - 2 * 4}px;
    height: ${TIME_SIZE - 2 * 4}px;
    margin: ${getSpacingToken('50')}px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: ${getToken('borderRadiusRound')};

    ${(props) =>
        !props.selected &&
        css`
            &:hover {
                background-color: ${getToken('backgroundInteractiveNeutralHover')};
            }
        `}

    ${(props) =>
        (props as $TSFixMe).selected &&
        css`
            font-weight: ${getToken('fontWeight600')};
        `}
`;
